<template>
    <div class="home body-box">

		<hero-section />

		<projects-section />

		<products-section />

		<news-letter />

		<ohilo-footer />
    </div>
</template>

<script>
// @ is an alias to /src
import OhiloFooter from '@/components/common/OhiloFooter.vue';
import HeroSection from '@/components/sections/HeroSection.vue';
import ProjectsSection from '@/components/sections/ProjectsSection.vue';
import ProductsSection from '@/components/sections/ProductsSection.vue';
import NewsLetter from '@/components/sections/NewsLetter.vue';

export default {
    name: "HomeView",
    components: {
        OhiloFooter,
		HeroSection,
        ProjectsSection,
        ProductsSection,
        NewsLetter,
	},
};
</script>